"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalLogger = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
// TODO: Delete - Using dynamic import to avoid ESM/CJS issues
let globalLogger = null;
exports.globalLogger = globalLogger;
try {
    const loggerModule = require("@daytrip/logger");
    const { Logger } = loggerModule;
    exports.globalLogger = globalLogger = new Logger({
        app: global.APPLICATION || "unknown",
        env: legacy_config_1.ENVIRONMENT,
        cid: "system-message",
    });
}
catch (error) {
    // Fallback if logger is not available
    console.warn("Logger not available:", error);
    exports.globalLogger = globalLogger = {
        info: () => { },
        error: () => { },
        warn: () => { },
        debug: () => { },
    };
}
//# sourceMappingURL=logger.js.map